/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/*
 * Interactive Badge component with Close
 *
 * @param {string} text: text to display
 * @param {function} onAction: optional close callback (will display an X if present)
 * @param {function} onCloseOverIcon: like onAction, but only fires when on X icon
 *
 */
import './Badge.scss';

export default function Badge(props) {
    const onCloseOverIcon = event => {
        event.stopPropagation();
        props.onCloseOverIcon(event);
    };
    const badgeProps = props.onAction ? {onClick: props.onAction} : {};
    const closeIconProps = props.onCloseOverIcon ? {onClick: onCloseOverIcon} : {};
    return (
        <div className={props.onAction ? 'ml-badge with-close' : 'ml-badge'} title={props.text} {...badgeProps}>
            <div className="text">{props.text}</div>
            {(props.onAction || props.onCloseOverIcon) && (
                <svg
                    {...closeIconProps}
                    className="close-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                >
                    <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                        <line fill="none" strokeMiterlimit="10" x1="16" y1="8" x2="8" y2="16" />{' '}
                        <line fill="none" strokeMiterlimit="10" x1="16" y1="16" x2="8" y2="8" />
                    </g>
                </svg>
            )}
        </div>
    );
}
